var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "margin-top": "20px" } }, [
    _c("div", { staticClass: "goods_msg" }, [
      _c("div", { staticClass: "goods_list" }, [
        _c("div", { staticClass: "goods_l" }, [_vm._v("物流名称")]),
        _vm._v("\n      " + _vm._s(_vm.oneBox.logisticsName) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goods_list" }, [
        _c("div", { staticClass: "goods_l" }, [_vm._v("发货仓库")]),
        _vm._v("\n      " + _vm._s(_vm.oneBox.orgName) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goods_list" }, [
        _c("div", { staticClass: "goods_l" }, [_vm._v("订单数量")]),
        _vm._v("\n      " + _vm._s(_vm.oneBox.orderCount) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goods_list" }, [
        _c("div", { staticClass: "goods_l" }, [_vm._v("箱数")]),
        _vm._v(
          "\n      " +
            _vm._s(_vm.oneBox.invoicePackageSize) +
            "（本箱为第" +
            _vm._s(_vm.oneBox.packageSize) +
            "箱）\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box_wrap" },
      _vm._l(_vm.oneBox.packageSubInfoDtoList, function(item, index) {
        return _c("div", { key: index, staticClass: "wrap_list" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: index == 0,
                  expression: "index == 0"
                }
              ],
              staticClass: "box_num"
            },
            [
              _vm._v("本箱内货物\n        "),
              _vm.oneBox.shipmentStatus == 2
                ? _c("div", { staticClass: "status_icon" }, [
                    _vm._v(
                      _vm._s(
                        _vm.oneBox.shipmentStatus == 2 ? "本箱不发做售后" : ""
                      )
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "product_box" }, [
            _c("img", {
              staticClass: "product_img",
              attrs: { src: item.modelThumbnailImg, alt: "" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "product_msg" }, [
              _c("div", { staticClass: "product_name" }, [
                _vm._v("产品名称：" + _vm._s(item.productName))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "model_name" }, [
                _vm._v("型号名称：" + _vm._s(item.modelName))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "model_num" }, [
                _vm._v("数量：" + _vm._s(item.modelCount))
              ])
            ])
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-325d8a6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-325d8a6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oneGoodsInfo.vue
// module id = null
// module chunks = 